import React from 'react'
import classNames from "classnames";

import PropTypes from "prop-types";

import Button from "components/CustomButtons/Button.jsx";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Divider from "@material-ui/core/Divider";
import Popper from "@material-ui/core/Popper";
import Icon from "@material-ui/core/Icon";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import { withNamespaces } from "react-i18next";

import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

// import bordersConfig from "config/BorderList.jsx";

// OpenLayers
import OlSourceTileWMS from "ol/source/TileWMS";
import OlLayerTile from "ol/layer/Tile" ;

import { API } from "services/api";

const gs_url = process.env.REACT_APP_GeoServer_Url;


function geoServerLayer(url, layerName) {
    return new OlLayerTile({
        source: new OlSourceTileWMS({
        //   crossOrigin: 'anonymous',
          params: {
            'LAYERS': layerName,
            'FORMAT': 'image/png'
          },
          url: url
        }),
        role: "border"
      })
}


class BorderSelector extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      selectedLayer: undefined,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);

    this.borders = [];

    API.getBorders()
    .then( data => {
        let first = true;
        let lastGroupId = undefined;
        this.borders = [];

        if (data && data.length > 0) {
          data.forEach(function(border)
          {
              if (!first && border.group_id !== lastGroupId) {
                  this.borders.push({ divider: true});
                  lastGroupId = border.group_id
              }
              border['display'] = border.title; //change
              border['displayCode'] = border.title_trans_token; //change?
              border['layer'] = geoServerLayer(gs_url, border.gs_layer)

              this.borders.push(border);

              first = false;
          }.bind(this));
        }
    });
  }

  handleClick = () => {
    this.setState(state => ({
      open: !state.open,
    }));
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false });
  };

  handleCloseMenu(param) {
    this.setState({
      open: false,
      selectedLayer: param
    });
    if (this.props && this.props.onClick) {
      this.props.onClick(param);
    }
  };

  render() {
    const { open } = this.state;

    const {
      t,
      classes,
      buttonText,
      buttonIcon,
      buttonProps,
      dropup,
    // dropdownHeader,
      caret,
      hoverColor,
      dropPlacement,
      noLiPadding,
      innerDropDown,
      navDropdown
    } = this.props;

    const caretClasses = classNames({
      [classes.caret]: true,
      [classes.caretDropup]: dropup && !open,
      [classes.caretActive]: open && !dropup
    });

    const dropdownItem = classNames({
      [classes.dropdownItem]: true,
      [classes[hoverColor + "Hover"]]: true,
      [classes.noLiPadding]: noLiPadding
    });

    const layersMenu = (
      <MenuList role="menu" className={classes.menuList}>
        {this.state.selectedLayer ?
          <MenuItem
            key={"none"}
            onClick={() => this.handleCloseMenu( null )}
            className={dropdownItem}
          >
            <Icon className={classes.dropdownIcons}>block</Icon>
            {t("map:clear-selection")}
          </MenuItem> : null
        }
        {this.state.selectedLayer ?
          <Divider
            onClick={() => this.handleCloseMenu("divider")}
            className={classes.dropdownDividerItem}
          />
            : null
        }
        {this.borders.map((prop, key) => {
          if (prop.header) {
            return (
              <MenuItem
                key={key}
                className={classes.dropdownHeader}
                disabled
              >
                {t(prop.displayCode)}
              </MenuItem>
            );
          }
          if (prop.divider) {
            return (
              <Divider
                key={key}
                onClick={() => this.handleCloseMenu("divider")}
                className={classes.dropdownDividerItem}
              />
            );
          }

            return (
                <MenuItem
                key={key}
                onClick={() => this.handleCloseMenu(prop)}
                className={dropdownItem}
                >
                  <Icon className={classes.dropdownIcons}>border_outer</Icon>
                  {prop.displayCode ? t(prop.displayCode) : prop.display}
                </MenuItem>
            );
            })}
        </MenuList>
        );

        return (
          <div className={innerDropDown ? classes.innerManager : classes.manager}>
            <div className={classNames(buttonText !== undefined ? "" : classes.target)}>
              <Button
                aria-label="Border Selection"
                aria-owns={open ? "menu-list-borders" : null}
                aria-haspopup="true"
                buttonRef={node => {
                this.anchorEl = node;
                }}
                {...buttonProps}
                onClick={this.handleClick}
              >
                {buttonIcon !== undefined ? (
                  <this.props.buttonIcon className={classes.buttonIcon} />
                ) : null}
                <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                  {/* {this.props.title} {this.state.selectedLayer ? ('(' + t(this.state.selectedLayer.displayCode) + ')') : null} */}
                  {this.state.selectedLayer ? t(this.state.selectedLayer.displayCode) : this.props.title }
                </div>
                {caret ? <b className={caretClasses} /> : null}
              </Button>
            </div>
            <Popper
              open={open}
              anchorEl={this.anchorEl}
              transition
              disablePortal
              placement={dropPlacement}
              className={classNames({
                [classes.popperClose]: !open,
                [classes.pooperResponsive]: true,
                [classes.pooperNav]: open && navDropdown
              })}
            >
            {({ TransitionProps, placement }) => (
              <Grow
                in={open}
                id="menu-list-borders"
                style={
                    dropup
                    ? { transformOrigin: "0 100% 0" }
                    : { transformOrigin: "0 0 0" }
                }
              >
                <Paper className={classes.dropdown}>
                  {innerDropDown ? (
                    layersMenu
                  ) : (
                    <ClickAwayListener onClickAway={this.handleClose} ref="cacat">
                      {layersMenu}
                    </ClickAwayListener>
                  )}
                </Paper>
              </Grow>
            )}
            </Popper>
          </div>
        );
    }
}


BorderSelector.defaultProps = {
  caret: true,
  dropup: false,
  hoverColor: "primary",
  buttonProps: {
    round: false,
    block: true,
    color: "primary"
  },
};

BorderSelector.propTypes = {
  classes: PropTypes.object.isRequired,
  hoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose"
  ]),
  buttonText: PropTypes.node,
  buttonIcon: PropTypes.func,
  layersList: PropTypes.array,
  buttonProps: PropTypes.object,
  dropup: PropTypes.bool,
  dropdownHeader: PropTypes.node,
  rtlActive: PropTypes.bool,
  caret: PropTypes.bool,
  dropPlacement: PropTypes.oneOf([
    "bottom",
    "top",
    "right",
    "left",
    "bottom-start",
    "bottom-end",
    "top-start",
    "top-end",
    "right-start",
    "right-end",
    "left-start",
    "left-end"
  ]),
  noLiPadding: PropTypes.bool,
  innerDropDown: PropTypes.bool,
  navDropdown: PropTypes.bool,
  // This is a function that returns the clicked menu item
  onClick: PropTypes.func
};

export default withNamespaces()(withStyles(mapStyle)(BorderSelector));